export function topHtml(): string {
  const lane = (i: number) => `
      <div class="raid-elite-lane" data-elite-lane="${i}" hidden>
        <div class="raid-boss-meta">
          <span data-elite-name></span>
          <span data-elite-bars></span>
          <span data-elite-phase></span>
        </div>
        <div class="raid-multibar" data-elite-multibar>
          <div class="raid-multibar-ghost" data-elite-ghost></div>
          <div class="raid-multibar-fill" data-elite-fill></div>
        </div>
        <div class="raid-toughbar" data-elite-toughbar>
          <div class="raid-toughbar-fill" data-elite-tough-fill></div>
        </div>
        <div class="raid-elite-status" data-elite-status hidden aria-hidden="true">
          <span class="raid-elite-status-break" data-elite-break hidden aria-hidden="true">
            <span class="raid-elite-status-icon" aria-hidden="true">⚡</span>
          </span>
          <span class="raid-escalate-badge" data-elite-escalate hidden aria-hidden="true">
            <span class="raid-escalate-icon" aria-hidden="true">▲</span>
            <span data-elite-escalate-n></span>
          </span>
        </div>
      </div>`;
  return `
    <div class="raid-top">
      <button type="button" class="menu-btn raid-quit" data-quit>Quit</button>
      <div class="raid-assault-chips" data-assault-chips hidden>
        <span data-assault-wave></span>
        <span class="raid-escalate-badge" data-assault-escalate hidden aria-hidden="true">
          <span class="raid-escalate-icon" aria-hidden="true">▲</span>
          <span data-assault-escalate-n></span>
        </span>
      </div>
      <div class="raid-boss-stack" data-boss-stack>
        <div class="raid-elite-lanes" data-elite-lanes>
          ${lane(0)}
          ${lane(1)}
          ${lane(2)}
        </div>
      </div>
      <div class="raid-top-row">
        <span data-party></span>
      </div>
      <div class="raid-toast" data-toast></div>
    </div>
  `;
}

/** Bottom dock: prep / commit-echo chip above mana. */
export function dockHtml(): string {
  return `
    <div class="raid-cmd-hud">
      <div class="raid-prep-chip" data-prep-chip aria-hidden="true">
        <span class="raid-prep-label" data-prep-label></span>
      </div>
      <div class="raid-mana-row">
        <div class="raid-mana-bar" data-mana-bar>
          <div class="raid-mana-fill" data-mana-fill></div>
        </div>
        <span class="raid-mana-text" data-mana-text></span>
      </div>
    </div>
  `;
}

export function resultHtml(won: boolean): string {
  return `
    <div class="menu-panel raid-result">
      <h2 data-result-title style="text-align:center;margin:0 0 8px">${won ? "WIN" : "LOSE"}</h2>
      <p data-result-body style="text-align:center;margin:0 0 16px"></p>
      <button type="button" class="menu-btn" data-retry>Roster</button>
      <button type="button" class="menu-btn" data-quit>Title</button>
    </div>
  `;
}
